import React, { Component } from 'react';
//import { Button } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import CloseIcon from '@material-ui/icons/Close';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import Grid from '@material-ui/core/Grid';
import Loader from '../../loader';
import { TextField, Table, TableCell, TableBody, TableHead, TableRow, Button, Box, Tooltip  } from '@material-ui/core';
import customeCSS from './PlanSelection.css';
import { connect } from 'react-redux';
import { Modal} from 'react-bootstrap';
// import {Panel} from 'react-bootstrap';
import axios from 'axios';
import configuration from '../../../configurations';
import CommonTable from "../../CommonScreens/commonTable";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import i18n from '../../../i18next';
import customStyle from '../../../Assets/CSS/stylesheet_UHS';
import moment from "moment";
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker,DatePicker} from '@material-ui/pickers';
import planConfig from "../../../planConfig";
import './Add-ons/addOnsScreen.css';
import { isnoSmartShare } from '../../../clientIDConfig';
const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
      color: '#fa6446',
  },
  tooltip: {
    backgroundColor: '#fa6446',
      border: '1px solid #dadde9',
      fontSize : '12px'
  },
}));

const useStylesBootstrap_otherQuote = makeStyles(theme => ({
    arrow: {
        color: '#4a4b57',
    },
    tooltip: {
        backgroundColor: '#4a4b57',
        border: '1px solid #dadde9',
        fontSize : '12px'
    },
}));


function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();
  return <Tooltip arrow classes={classes} {...props} />;
}

function BootstrapTooltipOtherQuote(props) {
  const classes = useStylesBootstrap_otherQuote();
  return <Tooltip arrow classes={classes} {...props} />;
}

const StyledTableCell = withStyles(theme => (customStyle.tableCell))(TableCell);
const StyledTableCell1 = withStyles(theme => (customStyle.tableCell1))(TableCell);

const StyledTableRow = withStyles(theme => (customStyle.tableRow))(TableRow);

function createData(NAME, AFA1, AFA2, AFA3, AFA4,AFA5,AFA6) {
  return { NAME, AFA1, AFA2, AFA3, AFA4,AFA5,AFA6 };
}

function createDataPB(NAME, PB2, PB4, PB6) {
    return { NAME, PB2, PB4, PB6 };
}

const row1=[
  createData('Non-Sharable Amount (NSA) Per Member	', '$1,000', '$1,500', '$2,500', '$5,000','$5,000','$6,000'),
  createData('Non-Sharable Amount (NSA) for 2 Persons	', '$2,000', '$3,000','$5,000','$10,000','$10,000','$12,000'),
  createData('Non-Sharable Amount (NSA) for 3 or more	', '$3,000','$4,500	','$7,500','$15,000','$15,000','$18,000'),
];
const row2=[
  createData('Application Fee	', '$75	','$75	','$75	','$75	','$75	','$75	'),
  createData('UHF Monthly Membership Dues	', '$15	','$15	','$15	','$15	','$15	','$15	'),
];

const row1pb=[
    createDataPB('Non-Sharable Amount (NSA) Per Member	', '$1,500', '$5,000', '$6,000'),
    createDataPB('Non-Sharable Amount (NSA) for 2 Persons	', '$3,000', '$10,000','$12,000'),
    createDataPB('Non-Sharable Amount (NSA) for 3 or more	', '$4,500','$15,000	','$18,000'),
];
const row2pb=[
    createDataPB('Application Fee	', '$75	','$75	','$75	'),
    createDataPB('UHF Monthly Membership Dues	', '$15	','$15	','$15	'),
];

function createData1(NAME, UHS1, UHS2, UHS3, UHS4,UHS5,UHS6) {
    return { NAME, UHS1, UHS2, UHS3, UHS4,UHS5,UHS6 };
}
const rowUhs1=[
    createData1('Non-Sharable Amount (NSA) Per Member	', '$1,000', '$1,500', '$2,500', '$5,000','$5,000','$6,000'),
    createData1('Non-Sharable Amount (NSA) for 2 Persons	', '$2,000', '$3,000','$5,000','$10,000','$10,000','$12,000'),
    createData1('Non-Sharable Amount (NSA) for 3 or more	', '$3,000','$4,500	','$7,500','$15,000','$15,000','$18,000'),
];
const rowUhs2=[
    createData1('Application Fee	', '$75	','$75	','$75	','$75	','$75	','$75	'),
    createData1('UHF Monthly Membership Fees	', '$15	','$15	','$15	','$15	','$15	','$15	'),
];

const ACSMrowUhsAll=[
    createData1('One Member per Household	', '$3,000', '$4,500', '$7,500', '$10,500','$15,000','$18,000'),
    createData1('Two Members per Household	', '$6,000', '$9,000','$15,000','$21,000','$30,000','$36,000'),
    createData1('Three or more Members per Household	', '$9,000','$13,500	','$22,500','$31,500','$45,000','$54,000'),
];

const ACSMrowUhs=[
    createData1('One Member per Household	',  '$4,500',  '$10,500','$18,000'),
    createData1('Two Members per Household	',  '$9,000','$21,000','$36,000'),
    createData1('Three or more Members per Household	', '$13,500	','$31,500','$54,000')
];

// Carrier drives which stepper/quote this session belongs to: "Sharing Programs" => UHF, "Insurance Plans" => VERA.
const getStepperTypeFromCookies = (cookiesData) => {
    return cookiesData.carrier || 'UHF';
};

// Columns to render, in first-seen order across all programs, excluding "link" and whichever
// "Family Total..." field(s) are used for the dedicated total column rendered at the end.
const getProgramColumns = (programs) => {
    let columns = [];
    (programs || []).forEach((p) => {
        Object.keys(p.values || {}).forEach((key) => {
            if (key === 'link' || key === 'Family Total' || key === 'Family Total With ACSM' || key === 'Family Total Without ACSM') return;
            if (!columns.includes(key)) columns.push(key);
        });
    });
    return columns;
};

// Tooltip text for a column header — programs carry their own per-key "tooltip" object, but the
// header is one shared row, so use the first non-empty tooltip found for that key across programs.
const getColumnTooltip = (programs, key) => {
    for (const p of (programs || [])) {
        if (p.tooltip && p.tooltip[key]) return p.tooltip[key];
    }
    return '';
};

// Only switch to "Family Total With ACSM" when the checkbox is checked AND this program
// actually supports ACSM — programs that don't support it always show their normal total,
// never the literal "NA" value the API returns for that field. Falls back to a plain
// "Family Total" field for carriers that don't have the With/Without ACSM pair at all.
const getProgramMonthlyValue = (program, acsmChecked) => {
    if (!program || !program.values) return null;
    let raw;
    if ('Family Total With ACSM' in program.values || 'Family Total Without ACSM' in program.values) {
        raw = (acsmChecked && program.acsmAvailable) ? program.values['Family Total With ACSM'] : program.values['Family Total Without ACSM'];
    } else {
        raw = program.values['Family Total'];
    }
    let parsed = parseFloat(raw);
    return isNaN(parsed) ? null : parsed;
};

const WhiteACSMCheckbox = withStyles({
    root: {
        color: '#ffffff',
        "&$checked": {
            color: '#ffffff',
        },
    },
    checked: {},
})(Checkbox);

const ProgramRadio = withStyles({
    root: {
        color: '#1a2c40',
        "&$checked": {
            color: '#1a2c40',
        },
    },
    checked: {},
})(Radio);

const ProceedButton = withStyles(
    customStyle.proceedBtn
)(Button);

const CustomeButton = withStyles(
    customStyle.viewBtn
)(Button);

const ViewButton = withStyles(
    customStyle.viewBtn
)(Button);

const BackButton = withStyles(
    customStyle.backBtn
)(Button);

const CssTextField = withStyles(theme => ({
  root: {
    '& .MuiInput-root': {
    "&:hover:not($disabled):not($focused):not($error):before": {
     borderBottom: '2px solid #1a2c40'
    },
   
  '&.MuiInput-underline.Mui-focused:after':{
    borderBottom: '2px solid #1a2c40',
},
  
 }
},
}))(TextField);


const styles = theme => ({
  table: {
    minWidth: 400,
  },
});

const ACSMCheckbox = withStyles({
    root: {
        color: '#1a2c40',
        "&$checked": {
            color: '#1a2c40',
        },
        "&$disabled": {
            color: 'grey'
        }
    },
    checked: {},
    disabled: {
        color: 'grey'
    }
})(Checkbox);


class PlanSelection extends Component {
  constructor(props) {
    super(props);
      const today = new Date();
      const tomorrow = new Date(today); 
      if(sessionStorage.getItem('CLIENT_ID') === '6548' || sessionStorage.getItem('CLIENT_ID') === '4367'
      || sessionStorage.getItem('CLIENT_ID') === '5540' || sessionStorage.getItem('CLIENT_ID') === '5647' || sessionStorage.getItem('CLIENT_ID') === '4391' || sessionStorage.getItem('CLIENT_ID') === '4390'
    //   || sessionStorage.getItem('CLIENT_ID') === '4376'
      || sessionStorage.getItem('CLIENT_ID') === '5541' || sessionStorage.getItem('CLIENT_ID') === '4377'
    //   || sessionStorage.getItem('CLIENT_ID') === '5558' || sessionStorage.getItem('CLIENT_ID') === '4386'
      ){
          if(new Date() < new Date("05/01/2021")){
              tomorrow.setDate(1);
              tomorrow.setMonth(4);
          } else if(new Date().getDate() === 1 ||  new Date().getDate() > 1){
              tomorrow.setDate(1);
              tomorrow.setMonth(today.getMonth() + 1);
          }
      } else {
          tomorrow.setDate(tomorrow.getDate() + 1);
      }

      if (this.props.isEmployer) {
          const snapped = this.nextEmployerEffectiveDate(tomorrow);
          tomorrow.setTime(snapped.getTime());
      }

      this.state = {
          loaderShow: false,
          programQuoteData: [],
          selectedProgramId: null,
          quoteLoading: true,
          sharingPlan: '',
          plansList: [],
          modalShow: false,
          selectedPlanCode : '',
          planFamilyDetails : [],
          otherQuote : [],
          todayPayment:[],
          recurringPayment:[],
          totalCost : '',
          headerData:[],
          tooltipData : [],
          checkedB: true,
          targetDate: new Date(tomorrow),
          dateErr:false,
          birthDtFocus:false,
          todayDateValid:false,
          birthDt:false,
          checkedPlan:false,
          Checked: '',
          clientId:sessionStorage.getItem('CLIENT_ID'),
          plansListNew : [],
          text:'',
          ACSMModal:false,
          reviewChoicesModal:false,
          reviewChoicesFullscreen:false,
          reviewChoicesTab:'summary',
          reviewChoicesLoading:false,
          reviewSummaryData:null,
          reviewFamilyData:null,
          count:0,
          ACSMValue : false,
          ACSMPlanAll:['UHS1','UHS3','UHS5','UHS6'],
          ACSMPlan:['UHS2','UHS4','UHS6'],
          disableACSM : true,
          smartShareModel : false,
          hideSmartShare : false,
          msgModal : false,
          errMsg : '',
          easyShareModal : false,
          empEffectiveDate : null,
          reEnroll: this.props.isChangeProgram || this.props.isHouseholdUpdate,
          nextRecurringDate:'',
          subId:  JSON.parse(localStorage.getItem('CurrentLoginUser')).id,
          appFee: 75,
          membershipDues: 15,
          employerEffectiveDate: null,
    };
  }

  componentDidMount() {
    this.setState({
        loaderShow: false
      });

    window.scrollTo(0, 0);
    sessionStorage.setItem('current_screen', String(this.props.activeStep));
    window.addEventListener('message', this.handlePlanGridSelection, false);
    this.handleDateChange(this.state.targetDate, true);
    this.fetchProgramQuote();
  }

    fetchProgramQuote = () => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
        let brokerId = cookiesData.brokerId;
        let type = cookiesData.actionType;
        let stepperType = getStepperTypeFromCookies(cookiesData);
        if (!subId || !brokerId) {
            this.setState({ quoteLoading: false });
            return;
        }
        axios.get(configuration.baseRootUrl + '/veraenroll/api/v1/quote/select-program/' + subId + '/' + brokerId + '/' + stepperType + `?type=${type}`)
            .then((response) => {
                let data = response.data;
                // Different carriers key the program list differently ("program" for UHF,
                // "programs" for others, e.g. VERA/EVEREST) — accept either.
                let programs = (data && (data.program || data.programs)) || [];
                if (!data || !programs.length) {
                    this.setState({ quoteLoading: false });
                    return;
                }
                let selectedProgram = programs.find(p => p.selected)
                    || programs.find(p => p.planId === data.selectedPlanId)
                    || programs[0];
                this.setState({
                    programQuoteData: programs,
                    selectedProgramId: selectedProgram.planId,
                    sharingPlan: selectedProgram.planName,
                    appFee: typeof data.applicationFee === 'number' ? data.applicationFee : this.state.appFee,
                    membershipDues: typeof data.membershipDues === 'number' ? data.membershipDues : this.state.membershipDues,
                    ACSMValue: !!data.acsmSelected,
                    checkedPlan: true,
                    quoteLoading: false,
                });
                if (data.effectiveDate) {
                    this.handleDateChange(new Date(data.effectiveDate));
                }
                this.fetchPackageSummary();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ quoteLoading: false });
            });
    }

    handlePlanGridSelection = (event) =>{
        let planId = JSON.parse(event.data);
        this.setState({
            Checked : planId.selected_val
        })
    }

    hideModal = (event,id) => {
      this.setState({
          modalShow: false
      });
  }
  hideACSMModal=(event)=>{
    this.setState({ACSMModal:false})
  }

  showACSMModal=()=>{
    this.setState({ACSMModal:true})
  }

  openReviewChoices = () => {
    this.setState({ reviewChoicesModal: true, reviewChoicesTab: 'summary', reviewChoicesFullscreen: false });
    this.fetchReviewChoicesData();
  }

  hideReviewChoices = () => {
    this.setState({ reviewChoicesModal: false, reviewChoicesFullscreen: false });
  }

  toggleReviewChoicesFullscreen = () => {
    this.setState({ reviewChoicesFullscreen: !this.state.reviewChoicesFullscreen });
  }

  // Fetches the combined program-fees + family-breakdown quote — drives the footer bar's total
  // and both tabs of the Review Choices modal (PROGRAM SUMMARY, FAMILY DETAILS) from one call.
  fetchPackageSummary = () => {
    let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
    let brokerId = cookiesData.brokerId;
    let stepperType = getStepperTypeFromCookies(cookiesData);
    let type = cookiesData.actionType;
    if (!subId || !brokerId) return Promise.resolve();

    return axios.get(configuration.baseRootUrl + '/veraenroll/api/v1/quote/review-choices/' + subId + '/' + stepperType + '/' + brokerId + `?productType=${type}`)
        .then((response) => {
            this.setState({
                reviewSummaryData: response.data.programFees,
                reviewFamilyData: response.data.familyBreakdown,
            });
        })
        .catch((error) => console.log(error));
  }

  // "Family Total for Sharing Programs" -> "Here's your first payment" — the same figure the
  // footer bar's total and the Review Choices summary tab should both show, sourced from the
  // backend's own calculation instead of a separate client-side estimate.
  getPackageFirstPaymentTotal = () => {
    let data = this.state.reviewSummaryData;
    if (!data || !data.body || !data.body.length) return null;
    let lastSection = data.body[data.body.length - 1];
    if (!lastSection || !lastSection.rows || !lastSection.rows.length) return null;
    let totalRow = lastSection.rows[lastSection.rows.length - 1];
    return totalRow ? totalRow.todayAmount : null;
  }

  fetchReviewChoicesData = () => {
    this.setState({ reviewChoicesLoading: true });
    this.fetchPackageSummary().then(() => {
        this.setState({ reviewChoicesLoading: false });
    }).catch((error) => {
        console.log(error);
        this.setState({ reviewChoicesLoading: false });
    });
  }

  // Persists the current program/ACSM pick so the backend's quote (and Review Choices) reflect it.
  // "addons" has no UI on this screen yet — pass through the same default entry the API expects.
  saveMemberPlanSelection = (program, acsmValue) => {
    if (!program) return;
    let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
    let brokerId = cookiesData.brokerId;
    let stepperType = getStepperTypeFromCookies(cookiesData);
    let productType = cookiesData.actionType || stepperType;
    if (!subId || !brokerId) return;

    axios.post(configuration.baseRootUrl + '/veraenroll/api/v1/quote/member-plan/updateByProduct', {
        subId: subId,
        agentId: brokerId,
        productType: productType,
        carrierCode: stepperType,
        plan: {
            planId: program.planId,
            planCode: program.planName,
            acsm: !!acsmValue,
        },
    }).then(() => {
        this.fetchPackageSummary();
    }).catch((error) => console.log(error));
  }

    showSmartShareModal = () => {
      window.open("https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-SmartShare-Program-Grid.pdf")
    }

    showEasyShareModal = () =>{
      window.open("https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-EasyShare-Program-Grid.pdf")
    }
  showPlansModal = (event) => {
      let plan = JSON.parse(JSON.stringify(this.state.plansList));
      let planIndex = plan.findIndex(obj => obj.planCode === "UHS SmartShare");
      let newPlan = this.state.plansList;
      let selectedPlanId = '';
      if(planIndex > -1){
          selectedPlanId = plan[planIndex].id;
          plan.splice(planIndex, 1);
      }
      let obj = planConfig.find(obj => obj.CLIENT_ID.toString() === this.state.clientId.toString());

      if(selectedPlanId === this.state.sharingPlan){
          this.setState({
              Checked : this.state.sharingPlan,
              plansListNew : plan,
          });
      } else {
          this.setState({
              Checked : this.state.sharingPlan,
              plansListNew : plan,
          });
      }
      window.open(obj.iframeURL)
  }

  submitPlan = (e) => {
    if (e.detail === 1){
      let selectedProgram = this.state.programQuoteData.find(p => p.planId === this.state.selectedProgramId);
      this.saveMemberPlanSelection(selectedProgram, this.state.ACSMValue);
      this.props.onClick();
    }
  }
  getValue =(val,itemValid,parentDetails)=>{
    let count =0;
    let ageValidator=0;
    if(parentDetails.flag === 'SELECT_PLAN'){

      if(parentDetails.label === 'Select Sharing Programs'){
        if(itemValid){
          this.state.sharingPlan = val;
        }else{
          this.state.sharingPlan = '';
        }

      } 
      }
    }

    isItemChecked(abilityName) {
      return parseInt(this.state.Checked) === parseInt(abilityName) ? true : false;
      //return this.state.Checked.indexOf(abilityName) > -1
    }
  


    handleDateChange = (date,didMount) => {
      this.setState({
          targetDate: date
      }
      , () =>{
            let panel = document.getElementById("date-picker-dialog");
            panel.addEventListener("onmouseleave", function() {
                document.getElementById("date-picker-dialog-label").style.paddingTop = "10px";
            });
        }
        );     
    }
    selectProgram = () => {
        this.setState({
            loaderShow : false,
            count: 1
        });
    }
    backToSelectProgram=()=>{
        this.setState({count:0})
    }

    handleStaticProgramSelect = (planId) => {
        let program = this.state.programQuoteData.find(p => p.planId === planId);
        // ACSM only applies to some programs — drop the checkbox if the new plan doesn't support it.
        let acsmValue = program && program.acsmAvailable ? this.state.ACSMValue : false;
        this.setState({
            selectedProgramId: planId,
            sharingPlan: program ? program.planName : '',
            checkedPlan: true,
            ACSMValue: acsmValue,
        });
        this.saveMemberPlanSelection(program, acsmValue);
    }

    handleStaticAcsmToggle = (e) => {
        let acsmValue = e.target.checked;
        this.setState({ ACSMValue: acsmValue });
        let selectedProgram = this.state.programQuoteData.find(p => p.planId === this.state.selectedProgramId);
        this.saveMemberPlanSelection(selectedProgram, acsmValue);
    }

 disableWeekends(date, clientId) {
    if (this.props.isEmployer) {
      if (date.getDate() === 1 || date.getDate() === 15) {
        return false;
      } else {
        return true;
      }
    }
     return false;
  }

    // Employer flow: snap a date forward to the next 1st or 15th of a month.
    // Returns the same Date if it is already on a valid day.
  nextEmployerEffectiveDate(date) {
    const d = new Date(date);
    const day = d.getDate();
    
    // If already on 1st or 15th, return as-is
    if (day === 1 || day === 15) {
        return d;
    }
    
    // Snap to next valid employer date (1st or 15th)
    if (day < 15) {
        d.setDate(15);
    } else {
        d.setMonth(d.getMonth() + 1);
        d.setDate(1);
    }
    
    return d;
}
getEmployerMinDate() {
    const today = new Date();
    const empEffDate = new Date(this.state.employerEffectiveDate);
    
    // If employerEffectiveDate is in the past, use today + 45 days
    if (empEffDate < today) {
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return this.nextEmployerEffectiveDate(tomorrow);
    }
    
    // If employerEffectiveDate is in the future, use it as baseline (+1 day)
    const minDateCalc = new Date(empEffDate.getTime() + 86400000); // +1 day
    return this.nextEmployerEffectiveDate(minDateCalc);
}

    // Add this new method to find the next enabled date
getNextEnabledDate(startDate, clientId) {
    if (!this.props.isEmployer) {
        return startDate;
    }

    const employerEffectiveDate = new Date(this.state.employerEffectiveDate);
    const maxDate = new Date(employerEffectiveDate);
    maxDate.setDate(maxDate.getDate() + 45);

    let currentDate = new Date(startDate);
    
    // Loop through dates until we find one that's not disabled
    while (currentDate <= maxDate) {
        if (!this.disableWeekends(currentDate, clientId)) {
            return currentDate;
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }
    
    // Fallback: return the snapped next employer effective date
    return this.nextEmployerEffectiveDate(startDate);
}

    render() {
        console.log('dadadadadadaad ', this.state.sharingPlan);
    let classes = this.props;
    let currentScreen = '';
    // UHF sharing programs have NSA/ACSM/etc.; other carriers (e.g. VERA insurance plans) don't —
    // their API just returns a flat "Family Total" and a null "link".
    const isUHF = getStepperTypeFromCookies(JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {}) === 'UHF';
    // Columns/headers come straight from whatever keys the API actually sent for these programs —
    // no static header list — so a new value column (or a carrier without ACSM at all) just works.
    const programColumns = isUHF ? getProgramColumns(this.state.programQuoteData) : [];
    // Only show the ACSM checkbox (and the "With/Without ACSM" Family Total suffix) when at least
    // one program in this response actually supports it — some carriers never offer it at all.
    const hasAnyAcsm = this.state.programQuoteData.some(p => p.acsmAvailable);
    let myDate=moment(this.state.targetDate).format('MM')+'/'+moment(this.state.targetDate).format('DD')+'/'+moment(this.state.targetDate).format('YYYY');
    const selectedProgram = this.state.programQuoteData.find(p => p.planId === this.state.selectedProgramId) || this.state.programQuoteData[0] || null;
    const selectedProgramMonthly = getProgramMonthlyValue(selectedProgram, this.state.ACSMValue) || 0;
    const quoteAppFee = parseFloat(this.state.appFee) || 0;
    const quoteMembershipDues = parseFloat(this.state.membershipDues) || 0;
    const firstPaymentTotal = (selectedProgramMonthly + quoteAppFee + quoteMembershipDues).toFixed(2);
    // Prefer the backend's own "Family Total for Sharing Programs" / "Here's your first payment"
    // figure (already formatted with $) once it's loaded; fall back to the client-computed estimate.
    const packageFirstPaymentTotal = this.getPackageFirstPaymentTotal();
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1); // Tomorrow's date

        let futureTomarow = new Date(today);
        let futureDate; // Will be 45 or 90 days from now
        if(this.state.clientId === '6548' || this.state.clientId === '4367' 
        || this.state.clientId === '5540' || this.state.clientId === '4376'
         || this.state.clientId === '5541' || this.state.clientId === '4377'
        //  || this.state.clientId === '5558' || this.state.clientId === '4386'
         ){
            if(new Date() < new Date("05/01/2021")){
                if(new Date() < new Date(this.state.empEffectiveDate)){
                    let efectiveDate = new Date(this.state.empEffectiveDate);
                    let effectiveDay = new Date(this.state.empEffectiveDate).getDate();
                    if(effectiveDay === 1 || effectiveDay > 1){
                        tomorrow.setDate(1);
                        tomorrow.setMonth(new Date(efectiveDate).getMonth() + 1);

                        futureTomarow.setDate(1);
                        futureTomarow.setMonth(new Date(efectiveDate).getMonth() + 1);
                    }

                } else {
                    tomorrow.setDate(1);
                    tomorrow.setMonth(4);
                    futureTomarow.setDate(1);
                    futureTomarow.setMonth(4)
                }
            } else if(new Date().getDate() === 1 ||  new Date().getDate() > 1){

                if(new Date() < new Date(this.state.empEffectiveDate)){
                    let efectiveDate = new Date(this.state.empEffectiveDate);
                    let effectiveDay = new Date(this.state.empEffectiveDate).getDate();
                    if(effectiveDay === 1 || effectiveDay > 1){
                        tomorrow.setDate(1);
                        tomorrow.setMonth(new Date(efectiveDate).getMonth() + 1);
                        futureTomarow.setDate(1);
                        futureTomarow.setMonth(new Date(efectiveDate).getMonth() + 1);
                    }
                } else {
                    tomorrow.setDate(1);
                    tomorrow.setMonth(today.getMonth() + 1);
                    futureTomarow.setDate(1);
                    futureTomarow.setMonth(today.getMonth() + 1)
                }
            }
            futureDate = futureTomarow.setDate(futureTomarow.getDate() + 45)
        } else {
            futureDate = futureTomarow.setDate(futureTomarow.getDate() + 90);
        }

        // Employer flow: push minDate forward to the next 1st or 15th so the
        // picker doesn't open on a month where every day is disabled.
        if (this.props.isEmployer) {
            const snapped = this.nextEmployerEffectiveDate(tomorrow);
            tomorrow.setTime(snapped.getTime());
        }


        let minDate = new Date(tomorrow);
        let maxDate = new Date(futureDate);

        
    if (this.props.isEmployer && this.state.employerEffectiveDate) {
        const empEffDate = new Date(this.state.employerEffectiveDate);

        let currentDate = today.setDate(today.getDate() + 45);
        
        // Check if employerEffectiveDate is in the past
        if (empEffDate < currentDate) {
            // Past date: use today + 45 days logic
            // const tomorrow45 = new Date(today);
            // tomorrow45.setDate(tomorrow45.getDate() + 45);
            minDate = this.nextEmployerEffectiveDate(currentDate);
            maxDate = new Date(minDate);
            maxDate.setDate(maxDate.getDate() + 45);
            // maxDate = this.nextEmployerEffectiveDate(maxDate);
            // myDate = moment(minDate).format('MM/dd/yyyy');
        } else {
            // Future date: use employerEffectiveDate as baseline
            // const tomorrow = new Date(empEffDate);
            // tomorrow.setDate(tomorrow.getDate() + 45);
            minDate = this.nextEmployerEffectiveDate(this.state.employerEffectiveDate);
            maxDate = new Date(minDate);
            maxDate.setDate(maxDate.getDate() + 45);
            // maxDate = this.nextEmployerEffectiveDate(maxDate);
            
            const targetDateObj = new Date(this.state.targetDate);
            const targetDay = targetDateObj.getDate();

            // Snap invalid target dates to 1st or 15th
            if (targetDay !== 1 && targetDay !== 15) {
                const snappedTargetDate = this.nextEmployerEffectiveDate(targetDateObj);
                myDate = moment(snappedTargetDate).format('MM/dd/yyyy');
            }
            
            // Ensure targetDate is within valid range
            // if (targetDateObj < minDate) {
            //     myDate = moment(minDate).format('MM/dd/yyyy');
            // } else if (targetDateObj > maxDate) {
            //     myDate = moment(maxDate).format('MM/dd/yyyy');
            // }
        }
        
        console.log('Employer flow minDate: ', minDate);
        console.log('Employer flow maxDate: ', maxDate);
        console.log('Employer flow myDate: ', myDate);
    }
       // const futureDate = this.state.clientId === '6548' ? futureTomarow.setDate(futureTomarow.getDate() + 45) : futureTomarow.setDate(futureTomarow.getDate() + 90);

        // ----------------------------------------------Screen 1----------------------------------------------------------

        if (this.state.count === 0) {

            currentScreen=
                <Grid container direction='column' className={this.props.isChangeProgram || this.props.isHouseholdUpdate ? "disabledReenrollPlanSelection" : ""} style={{width:'100%'}}>
                    <p style={{ fontSize: '14px', lineHeight: '20px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>
                        Review the programs available, compare contribution amounts and click the <b>ADD</b> button. Once you&rsquo;ve chosen your program, then <b>Select Program Effective Date</b> to choose when you want your program to begin. Finally, click <b>SELECT PROGRAM</b> to proceed.
                    </p>
                    <br/>
                    <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100%' }}>
                        <div style={customStyle.programCompareScrollBody}>
                            <table style={customStyle.programCompareTable}>
                                <thead>
                                    <tr>
                                        <th style={customStyle.programCompareHeaderCell}>Program</th>
                                        {isUHF && programColumns.map((col) => {
                                            const tooltipText = getColumnTooltip(this.state.programQuoteData, col);
                                            return (
                                                <th key={col} style={customStyle.programCompareHeaderCell}>
                                                    <div style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                        <span>{col}</span>
                                                        {tooltipText &&
                                                            <BootstrapTooltipOtherQuote title={tooltipText} arrow>
                                                                <InfoOutlinedIcon style={{fontSize:'14px', cursor:'pointer'}} />
                                                            </BootstrapTooltipOtherQuote>
                                                        }
                                                    </div>
                                                </th>
                                            );
                                        })}
                                        {!isUHF && <th style={customStyle.programCompareHeaderCell}>Benefit Tier<br/></th>}
                                        <th style={customStyle.programCompareHeaderCell}>Family Total{isUHF && hasAnyAcsm && <><br/>{this.state.ACSMValue ? 'With ACSM' : 'Without ACSM'}</>}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.quoteLoading ? (
                                        <tr><td style={customStyle.programCompareCell} colSpan={isUHF ? programColumns.length + 2 : 3}><Loader></Loader></td></tr>
                                    ) : this.state.programQuoteData.length === 0 ? (
                                        <tr><td style={customStyle.programCompareCell} colSpan={isUHF ? programColumns.length + 2 : 3}>No programs are available for this enrollment.</td></tr>
                                    ) : this.state.programQuoteData.map((program) => {
                                        const selected = program.planId === this.state.selectedProgramId;
                                        const monthlyValue = getProgramMonthlyValue(program, this.state.ACSMValue);
                                        return (
                                            <tr key={program.planId}
                                                style={selected ? customStyle.programCompareRowSelected : customStyle.programCompareRow}
                                                onClick={() => this.handleStaticProgramSelect(program.planId)}
                                            >
                                                <td style={customStyle.programCompareCell}>
                                                    <ProgramRadio
                                                        checked={selected}
                                                        onChange={() => this.handleStaticProgramSelect(program.planId)}
                                                        style={{ padding: 0, marginRight: '8px' }}
                                                    />
                                                    Add <b>{program.planName}</b>
                                                </td>
                                                {isUHF && programColumns.map((col) => (
                                                    <td key={col} style={customStyle.programCompareCell}>{program.values[col]}</td>
                                                ))}
                                                {!isUHF && <td style={customStyle.programCompareCell}>Primary</td>}
                                                <td style={customStyle.programCompareCell}>
                                                    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                                                        <span>
                                                            {monthlyValue !== null ? (
                                                                <>
                                                                    <span style={customStyle.programCompareTotal}>${monthlyValue.toFixed(2)}</span>
                                                                    <span style={customStyle.programComparePerMonth}>/MONTH</span>
                                                                </>
                                                            ) : (
                                                                <span style={customStyle.programCompareTotal}>N/A</span>
                                                            )}
                                                        </span>
                                                        {program.values.link &&
                                                            <span style={customStyle.programCompareViewDetails} onClick={(e) => { e.stopPropagation(); window.open(program.values.link); }}>VIEW DETAILS</span>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div style={customStyle.programCompareFooterBar} className="pcFooterBar">
                            <div style={{display:'flex', alignItems:'center', gap:'16px'}} className="pcFooterGroupA">
                            {isUHF && hasAnyAcsm &&
                            <div style={{display:'flex', alignItems:'center'}}>
                                <WhiteACSMCheckbox
                                    checked={this.state.ACSMValue}
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    disabled={this.props.isChangeProgram || this.props.isHouseholdUpdate || !(selectedProgram && selectedProgram.acsmAvailable)}
                                    style={{ marginLeft:'-11px' }}
                                    onClick={(event) => this.handleStaticAcsmToggle(event)}
                                />
                                <div style={customStyle.programCompareFooterLabel}>
                                    Include <b>Annual Co-Share<br/>Maximum (ACSM)</b>
                                </div>
                            </div>
                            }
                            <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'12px', minWidth:'260px'}} className="pcDateFieldRow">
                                <span style={customStyle.programCompareFooterLabel}>Select Program<br/>Effective Date*</span>
                                <div style={customStyle.programCompareDateBox} className="pcDateBox">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            required
                                            onBlur={()=>this.setState({birthDtFocus:true})}
                                            onMouseOver={()=>this.setState({birthDt:true})}
                                            onMouseLeave={()=>this.setState({birthDt:false})}
                                            autoComplete='off'
                                            margin="none"
                                            id="date-picker-dialog"
                                            format="MM/dd/yyyy"
                                            disabled={true}
                                            error={this.state.dateErr}
                                            helperText={this.state.dateErr?'Enter valid date':''}
                                            value={myDate}
                                            onFocus={e => e.target.blur()}
                                            onCopy={this.handlerCopy}
                                            onPaste={this.handlerCopy}
                                            InputProps={{ disableUnderline: true, style: { color: '#ffffff' } }}
                                            inputProps={{style: {fontSize:'15px',fontFamily: 'Roboto, Arial, Helvetica, sans-serif',padding:'0px 0px 10px 11px','&:focus':{ outline: 'none'},color:'#ffffff'}}}
                                            onChange={this.handleDateChange.bind(this)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date', style: { color: '#ffffff' } }}
                                            style={{width:'100%'}}
                                            shouldDisableDate={(e) => this.disableWeekends(e, this.state.clientId)}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            </div>
                            <div style={{textAlign:'left', display:'flex',}} className="pcFooterGroupB">
                                <div style={{textAlign:'left', display:'flex', flexDirection:'column', marginRight:'12px'}}>
                                <span style={customStyle.programCompareFooterTotal}>{packageFirstPaymentTotal || ('$' + firstPaymentTotal)}</span>
                                <div style={customStyle.programCompareFooterNote}>
                                    <InfoOutlinedIcon style={{fontSize:'15px'}} />
                                    Includes other applicable fees
                                </div>
                                </div>
                                <div style={{position:'relative', cursor:'pointer', display: 'flex', alignItems: 'center'}} onClick={this.openReviewChoices}>
                                <ShoppingCartIcon style={{color:'#ffffff', fontSize:'28px'}} />
                                <span style={customStyle.programCompareCartBadge}>1</span>
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </Grid>
        }

// ------------------------------------------------Screen 2----------------------------------------------------------------

        if (this.state.count === 1) {
            currentScreen=<Grid container style={{marginTop:'1%'}}>
            <Grid item xs={12} md={7} sm={7} xl={6} lg={7}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={11} md={11} xl={10} style={{backgroundColor:'#e4e5e6',paddingLeft:'10px'}}>

            <Grid container justify='space-between' direction='row'>
                <Grid item sm={4} md={4} lg={4} xs={12}>
                    <span style={customStyle.headingTxt}>Your program selection :</span>
                    <div style={customStyle.planTextProgramSelection}>{this.state.selectedPlanCode}</div>            
                    <div style={customStyle.planTextCheckACSM}>{this.state.ACSMValue && " +Annual Co-Share Maximum "}</div>
                </Grid>
           
            <Grid item sm={8} md={8} lg={8} xs={12} style={{paddingLeft:'10px'}}>


            <span style={customStyle.headingTxt}>Here's what you'll recieve  :</span>
                {this.state.otherQuote.map((op,index) => (

                  <div key={index} style={{display:'flex',paddingTop:'5px'}} >

                       <span style={customStyle.planTextACSM}> {op.text}
                        {
                           (op.tooltip !== "" && op.tooltip !== null) &&
                               <BootstrapTooltipOtherQuote title={op.tooltip} placement='top'>
                                   <InfoOutlinedIcon style={{ color : '#4a4b57', marginBottom: "3px"}} fontSize="small"></InfoOutlinedIcon>
                               </BootstrapTooltipOtherQuote>
                        }
                       </span>
                        <span style={{width : '25%', fontFamily : 'Roboto, Arial, Helvetica, sans-serif'}}><b> {op.amount} </b></span>
                  </div>


                ))}
            </Grid>
            </Grid>            
              
            </Grid>               
            </Grid>

             <Grid  container spacing={1} style={{marginTop:'2%'}} >
               <Grid item xs={12} sm={12} md={6} xl={5} lg={6} style={{backgroundColor:'#f1f1f1',borderTop: '5px solid #fff',paddingLeft:'10px',borderRight:'3px solid #fff'}}>
               <span style={customStyle.headingTxt}>Here's what you'll pay today :</span>
               {this.state.todayPayment.map((op,index) => (
                                       <div key={index} style={index!==3?customStyle.planBox:customStyle.planBoxTotal} >
                                       <div style={index!==3?customStyle.planTextGrid:customStyle.planTextTotal}> {op.text}</div>
                                       <div style={customStyle.planPrice}>  {op.amount}</div>
                                       </div>
                                   ))}
               </Grid>

               <Grid item xs={1}  style={{maxWidth:'3px'}} ></Grid>
               
               <Grid item xs={12} sm={12} md={5} xl={4} lg={5} style={{backgroundColor:'#f1f1f1',borderTop: '5px solid #fff',paddingLeft:'10px',borderLeft:'3px solid #fff',borderRight:'7px solid #fff'}}>
               <span style={customStyle.headingTxt}>Here's your regular monthly payment  :</span>
               {this.state.recurringPayment.map((op,index) => (
                                       <div key={index} style={index!==2?customStyle.planBox:customStyle.planBoxTotalselectprog} >
                                       <div style={index!==2?customStyle.planTextGrid:customStyle.planTextTotal}> {op.text}</div>
                                       <div style={index!==2?customStyle.planPrice:customStyle.planPriceRec2}>  {op.amount}</div>
                               </div>
                               ))} 
               </Grid>
             </Grid>
             <Grid container spacing={1} style={{marginTop:'1%'}}>
               <Grid item xs={12} sm={12} md={11} xl={10} style={{textAlign:'justify',fontSize:'13px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif'}} >
               {this.state.text}
               </Grid>
               </Grid>
           </Grid>
       
           <Grid item xs={12} sm={12} md={5} xl={4}>
             <Grid container spacing={2} >
               <Grid item xs={12} style={{height:'80%',marginRight:'1px', overflowY:'auto'}} >
               <div style={{overflowX:'auto'}} className="reivewTable">
                   <CommonTable quoteData={this.state.planFamilyDetails} check={this.state.checkedPlan} headerData={this.state.headerData} tooltip={this.state.tooltipData} quickQuote={false} totalReq={true} />
               </div>
               </Grid>
             </Grid>
           </Grid>
         </Grid> 
        }



    return (
      <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', rowGap: '16px' }}>


                    <div style={{ marginTop: '22px', width: '100%', display: 'flex', paddingBottom: 30, flexShrink: 0 }}>
                        {currentScreen}
                    </div>

                {/* ============================= Button ============================================= */}
                    {
                        this.state.count === 0
                        ?
                        <div style={{display:'flex', flexWrap:'wrap', gap:'24px', marginTop:'auto'}}>
                            <BackButton color="primary" onClick={this.props.handlePrev}>BACK</BackButton>
                            <ProceedButton color="primary" disabled={ this.state.sharingPlan === '' && this.state.targetDate === ''} onClick={this.submitPlan}>{this.props.isChangeProgram || this.props.isHouseholdUpdate? "CONTINUE" :"Select Program"}</ProceedButton>{/* this.selectProgram */}
                        </div>
                        :
                        <div style={{display:'flex', flexWrap:'wrap', gap:'24px', marginTop:'auto'}}>
                            <BackButton color="primary" onClick={this.backToSelectProgram}>BACK</BackButton>
                            <ProceedButton color="primary" disabled={ this.state.sharingPlan === '' && this.state.targetDate === ''} onClick={this.submitPlan} >Proceed</ProceedButton>
                        </div>

                    }
                    


        {/* --------------------------------ACSM Modal ------------------------------------------------- */}

        <Modal size="lg" show={this.state.ACSMModal}  onHide={(event) => this.hideACSMModal(event)} backdrop="static" className="psModalDialog" backdropClassName="psModalBackdrop">
        <Modal.Header style={customStyle.modal_header} closeButton>
              <Modal.Title>Annual Co-Share Maximum for UHS Standard Programs Only</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '15px' ,textAlign : 'justify', overflowX : 'hidden', fontfamily: 'Roboto, Arial, Helvetica, sans-serif'}}>
              {
                  this.state.loaderShow ? <Loader></Loader> : ''
              }
              <span style={{fontSize:'13px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif'}}>If you choose this option, 100% of your Eligible Medical Expenses become sharable when your Annual Co-Share Maximum (ACSM)
               has been met. The ACSM differs for each program. Also, the Preventive Care is increased to $1,000 per member per year 
               (subject to a 90-day waiting period). Check the box for the ACSM option and you can view the difference in monthly contribution 
               amounts for each program.
               </span>

                  <div style={{ overflowX: "auto" }} >
                    <Table aria-label="customized table1"  style={customStyle.tableACSM}>
                   <TableHead style={{backgroundColor:'#1a2c40',position: 'sticky'}}>
                   <TableRow style={{position: 'sticky'}}>
                   <StyledTableCell1 padding='checkbox' align='center' style={customStyle.tableHead1ACSM} >
                                      Program Name
                    </StyledTableCell1>
                       {
                           (true) ?
                               this.state.ACSMPlanAll.map((option, index) => (
                                   <StyledTableCell1 style={customStyle.tableHead2ACSM}  align='center' key={index} value={option.id}>
                                       {option}
                                   </StyledTableCell1>

                               )) :
                               this.state.ACSMPlan.map((option, index) => (
                                   <StyledTableCell1 style={customStyle.tableHead2ACSM}  align='center' key={index} value={option.id}>
                                       {option}
                                   </StyledTableCell1>

                               ))

                       }
                   </TableRow>
                   </TableHead>

                   <TableBody >
                   <StyledTableRow align='center' style={customStyle.rowHead} >
                   <StyledTableCell1  align="center" style={customStyle.tableRowHeadACSM} >
                        <text style={{color: '#fff'}}>Annual Out-of-Pocket</text>
                                      </StyledTableCell1>
                                      <StyledTableCell1  align="center" colSpan={4} style={customStyle.tableRowHead2ACSM} >
                                        <text style={{color: '#fff'}}>Annual Co-Share Maximum Amounts</text>
                                      </StyledTableCell1>
                    </StyledTableRow>
                       {
                           (true) ?
                               ACSMrowUhsAll.map((row,index) => (

                                   <StyledTableRow align="left" style={{backgroundColor:'rgba(46, 49, 146, 0.2)',border : '2px solid #ffffff'}} key={index}>
                                       <StyledTableCell component="th" scope="row" style={customStyle.cellTitle}>
                                           {row.NAME}
                                       </StyledTableCell>
                                       <StyledTableCell align="center" style={customStyle.cellChild}  >{row.UHS1}</StyledTableCell>
                                       {/* <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS2}</StyledTableCell> */}
                                       <StyledTableCell align="center" style={customStyle.cellChild}>{row.UHS3}</StyledTableCell>
                                       {/* <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS4}</StyledTableCell> */}
                                       <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS5}</StyledTableCell>
                                       <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS6}</StyledTableCell>
                                   </StyledTableRow>
                               )) :
                                   ACSMrowUhs.map((row,index) => (

                                       <StyledTableRow align="center" style={{backgroundColor:'rgba(46, 49, 146, 0.2)',border : '2px solid #ffffff'}} key={index}>
                                           <StyledTableCell component="th" scope="row" style={customStyle.cellTitle}>{row.NAME}</StyledTableCell>
                                           <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS1}</StyledTableCell>
                                           <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS2}</StyledTableCell>
                                           <StyledTableCell align="center" style={customStyle.cellChild} >{row.UHS3}</StyledTableCell>
                                       </StyledTableRow>
                                   ))
                       }


                   </TableBody>

                   </Table>
                  </div> 
               <span style={{fontSize:'13px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif'}}>
                        The amounts shown above are Co-Share Maximum amounts in effect as of 10/01/2020. Annual Co-Share Maximum amounts are subject 
                        to adjustment from time to time. Always remember to check the Universal HealthShare Member Portal for the most current version
                        of the Sharing Guidelines, which may reflect changes that have been made since the date of the last copy you reviewed. 
                        This option is only available at the time of enrollment, or at the time of annual program renewal.
                </span>
            </Modal.Body>
            <Modal.Footer>
            <CustomeButton style={{ padding: '11px 20px', lineHeight: 'normal' }} onClick={(event) => this.hideACSMModal(event)}>{i18n.t('BUTTON.DONE')}</CustomeButton>
          </Modal.Footer>
        </Modal>

        {/* --------------------------------Review Choices Modal (cart icon) ------------------------------------------------- */}

        <Modal size={this.state.reviewChoicesFullscreen ? 'xl' : 'lg'} show={this.state.reviewChoicesModal} onHide={this.hideReviewChoices} backdrop="static" className="psModalDialog" backdropClassName="psModalBackdrop">
            <div style={customStyle.reviewChoicesHeader}>
                <span style={customStyle.reviewChoicesTitle}>Review Choices</span>
                <span style={customStyle.reviewChoicesHeaderIcons}>
                    <FullscreenIcon onClick={this.toggleReviewChoicesFullscreen} />
                    <CloseIcon onClick={this.hideReviewChoices} />
                </span>
            </div>
            <div style={customStyle.reviewChoicesTabs} className="reviewChoicesTabsResponsive">
                <div
                    style={this.state.reviewChoicesTab === 'summary' ? customStyle.reviewChoicesTabActive : customStyle.reviewChoicesTabInactive}
                    className="reviewChoicesTabResponsive"
                    onClick={() => this.setState({ reviewChoicesTab: 'summary' })}
                >PROGRAM SUMMARY</div>
                <div
                    style={this.state.reviewChoicesTab === 'family' ? customStyle.reviewChoicesTabActive : customStyle.reviewChoicesTabInactive}
                    className="reviewChoicesTabResponsive"
                    onClick={() => this.setState({ reviewChoicesTab: 'family' })}
                >FAMILY DETAILS</div>
            </div>
            {
                this.state.reviewChoicesLoading ? <Loader></Loader> :
                this.state.reviewChoicesTab === 'summary' ?
                (
                    this.state.reviewSummaryData ?
                    <div style={{ padding: '20px', background: '#f0f0f2' }}>
                        <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100%', paddingRight: '16px', boxSizing: 'border-box' }}>
                            <div style={customStyle.reviewChoicesScrollBody}>
                                <table style={customStyle.reviewChoicesTable}>
                                    <thead>
                                        <tr>
                                            {this.state.reviewSummaryData.header.map((headerText, hIndex) => (
                                                <th key={hIndex} style={hIndex === 0 ? customStyle.reviewChoicesTableHeaderCell : customStyle.reviewChoicesTableHeaderCellBold}>{headerText}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.reviewSummaryData.body.filter((section) => Array.isArray(section.rows) && section.rows.length).map((section, sectionIndex) => (
                                            section.rows.slice(0, -1).map((row, rowIndex) => (
                                                <tr key={sectionIndex + '-' + rowIndex}>
                                                    <td style={customStyle.reviewChoicesTableCell}>{row.text}</td>
                                                    <td style={customStyle.reviewChoicesTableCell}>{row.todayAmount}</td>
                                                    <td style={customStyle.reviewChoicesTableCell}>{row.regularAmount}</td>
                                                </tr>
                                            ))
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        {this.state.reviewSummaryData.body.filter((section) => Array.isArray(section.rows) && section.rows.length).map((section, sectionIndex) => {
                                            const totalRow = section.rows[section.rows.length - 1];
                                            // A single-row section has no separate line items above it (slice(0, -1)
                                            // is empty) — this row is the section's only content, not a bolded total,
                                            // so it shouldn't get the dark #47454a "total" background.
                                            const totalCellStyle = section.rows.length === 1
                                                ? { ...customStyle.reviewChoicesTotalCell, backgroundColor: '#f7f7f7', color: '#19191d' }
                                                : customStyle.reviewChoicesTotalCell;
                                            return (
                                                <tr key={'total-' + sectionIndex} style={customStyle.reviewChoicesTotalRow}>
                                                    <td style={totalCellStyle}>{totalRow.text}</td>
                                                    <td style={totalCellStyle}>{totalRow.todayAmount}</td>
                                                    <td style={totalCellStyle}>{totalRow.regularAmount}</td>
                                                </tr>
                                            );
                                        })}
                                        {(() => {
                                            const grandTotalEntry = this.state.reviewSummaryData.body.find((item) => !Array.isArray(item.rows));
                                            return grandTotalEntry ? (
                                                <tr style={customStyle.reviewChoicesTotalRow}>
                                                    <td style={customStyle.reviewChoicesTotalCell}>{grandTotalEntry.title}</td>
                                                    <td style={customStyle.reviewChoicesTotalCell}>{grandTotalEntry.todayAmount}</td>
                                                    <td style={customStyle.reviewChoicesTotalCell}>{grandTotalEntry.regularAmount}</td>
                                                </tr>
                                            ) : null;
                                        })()}
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <div style={customStyle.reviewChoicesDisclaimer}>
                            *The total amount will include a 3.5% charge for the use of a credit card as your payment method.<br/>
                            To avoid this charge, please use ACH as your payment method in the screen that follows.
                        </div>
                    </div>
                    :
                    <div style={{ padding: '20px', fontSize:'14px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>No data available.</div>
                )
                :
                (
                    this.state.reviewFamilyData ?
                    (() => {
                        // Flat shape from /quote/review-choices: header is ["Family Member", "<Plan>", "Surcharge", "Total"],
                        // rows are [{memberId, name, plan, surcharge, total}, ...] with a trailing {name: "Family Total", ...} row.
                        const familyHeader = this.state.reviewFamilyData.header || [];
                        const rows = this.state.reviewFamilyData.rows || [];
                        const memberRows = rows.filter((row) => row.name !== 'Family Total');
                        const totalRow = rows.find((row) => row.name === 'Family Total');
                        return (
                            <div style={{ padding: '20px', background: '#f0f0f2' }}>
                                <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100%', paddingRight: '16px', boxSizing: 'border-box' }}>
                                    <div style={customStyle.reviewChoicesScrollBody}>
                                        <table style={customStyle.reviewChoicesTable}>
                                            <thead>
                                                <tr>
                                                    {familyHeader.map((headerText, hIndex) => (
                                                        <th key={hIndex} style={hIndex === 0 ? customStyle.reviewChoicesTableHeaderCell : customStyle.reviewChoicesTableHeaderCellBold}>{headerText}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {memberRows.map((row, rowIndex) => (
                                                    <tr key={row.memberId || rowIndex}>
                                                        <td style={customStyle.reviewChoicesTableCell}>{row.name}</td>
                                                        <td style={customStyle.reviewChoicesTableCell}>{row.plan}</td>
                                                        <td style={customStyle.reviewChoicesTableCell}>{row.surcharge}</td>
                                                        <td style={customStyle.reviewChoicesTableCellHighlight}>{row.total}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            {totalRow &&
                                                <tfoot>
                                                    <tr style={customStyle.reviewChoicesTotalRow}>
                                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.name}</td>
                                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.plan}</td>
                                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.surcharge}</td>
                                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.total}</td>
                                                    </tr>
                                                </tfoot>
                                            }
                                        </table>
                                    </div>
                                </div>
                                  <div style={customStyle.reviewChoicesDisclaimer}>
                            *The total amount will include a 3.5% charge for the use of a credit card as your payment method.<br/>
                            To avoid this charge, please use ACH as your payment method in the screen that follows.
                        </div>
                            </div>
                        );
                    })()
                    :
                    <div style={{ padding: '20px', fontSize:'14px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>No data available.</div>
                )
            }
        </Modal>

          <Modal size="xs" show={this.state.msgModal} onHide={(event) => this.setState({msgModal:false,loaderShow : false, errMsg : ''})} backdrop="static" centered className="psModalDialog" backdropClassName="psModalBackdrop">
              <Modal.Header style={customStyle.modal_header} closeButton>
                  <Modal.Title>Error Message</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ margin: '10px',textAlign:'center',fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>
                  {this.state.errMsg}
              </Modal.Body>
              <Modal.Footer style={{alignItems:'right'}}>
                  <CustomeButton style={{marginTop: '10px', padding: '11px 20px', lineHeight: 'normal'}} onClick={()=>{this.setState({ msgModal : false,loaderShow : false, errMsg : ''})}}>Ok</CustomeButton>
              </Modal.Footer>
          </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    subId: state.subId
  };
}

export default withStyles(styles)(connect(mapStateToProps)(PlanSelection));
